import styled, { css } from 'styled-components'
import { flexBox, fontSize } from '../../shared/styles/mixins'

export const PrecedureList = styled.ul`
  width: 100%;
  height: 80px;
  ${flexBox('row wrap', 'space-between', 'center')}
  display: flex;
  text-align: left;
  padding: 12px 26px;
  li {
    width: ${({size}) => size ||  '48%' };
    ${fontSize(10)}
    font-weight: 500;
  }

  ${({ complete }) =>
    complete &&
    css`
      @media screen and (min-width: 600px) {
        height: 140px;
        flex-flow: column;
        align-items: flex-start;

        li {
          width: 100%;
        }
      }
    `}
`

export const ListMarker = styled.span`
  color: #fe3e64;
`
export const AllProcedures = styled.section`
  width: 100%;
  padding: 0 26px;
  ${flexBox('row wrap', 'space-between', 'center')};
  ${fontSize(10)};
  margin-bottom: 22px;
`